module.exports = __webpack_public_path__ + "img/Platform_Gradients-16.8e08164d.jpg";